import { useMemo, useState } from 'react';
import { HostQualityFilter } from './hostQuality/types/HostQuality.types';
import HostQualityContext from './HostQualityContext';

const HostQualityContextProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const [hostQualityFilter, setHostQualityFilter] = useState<
    HostQualityFilter | undefined
  >(undefined);

  const contextValue = useMemo(
    () => ({
      hostQualityFilter,
      setHostQualityFilter,
    }),
    [hostQualityFilter],
  );

  return (
    <HostQualityContext.Provider value={contextValue}>
      {children}
    </HostQualityContext.Provider>
  );
};

export default HostQualityContextProvider;
